import { render } from "./ProductPublishDateDialog.vue?vue&type=template&id=aa89e19e"
import script from "./ProductPublishDateDialog.vue?vue&type=script&lang=js"
export * from "./ProductPublishDateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__